<template>
    <div class=" loginpage">
 <div class="block session animated" :class="{ 'shake' : this.$store.getters.autherror }">
    <div class="left" v-if="mode == 'form'">
    </div>

    <div class="form qrcodeholder" :class="{ 'successqr' : success, 'failqr' : fail }" v-if="mode == 'qrcode'">
      <div id="reader" style="600px; margin: auto;">
      </div>
    </div>

    <div class="form" v-if="mode == 'form'">
      <h4><span>PhoenixDx<sup>&reg;</sup></span> Portal</h4>
      <p>
        {{ transl["STR_TITLE_WELCOME"] }}
      </p>

      <div class="floating-label">
        <input :placeholder='transl["STR_EMAIL"]' autofocus type="email" ref="username" v-model="username" autocomplete="off">
        <label for="email">{{ transl["STR_EMAIL"] }}:</label>
      </div>


      <div class="floating-label">
        <input :placeholder='transl["STR_CUSTID"]'  type="password" v-model="password" ref="password" autocomplete="off">
        <label for="password">{{ transl["STR_CUSTID"] }}:</label>
      </div>
      <button style="width: 250px;" type="submit" v-on:click="Login()">
        {{ transl["STR_LOGIN"] }}
      </button>
      <select v-model="currLang">
        <option v-for="lng in translation" :value="lng.LANG_CODE">{{ lng.LANG_NAME }}</option>
      </select>
      <label>{{GetVersion()}}</label>
    </div>
  </div>
    </div>
</template>
<style scoped>
@media only screen and (max-width: 800px) {
  .left { display: none !important; }
  .form {
    width: 100% !important;
  }
  .session {
    height: 100% !important;
    width: 100% !important;
  }
}

* {
  font-family: -apple-system, BlinkMacSystemFont, "San Francisco", Helvetica, Arial, sans-serif;
  font-weight: 300;
  margin: 0;
}

html, body {
  height: 100vh;
  width: 100vw;
  margin: 0 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  background: #f3f2f2;
}

h4 {
  font-size: 24px;
  font-weight: 600;
  color: #000;
  opacity: 0.85;
}

label {
  font-size: 12.5px;
  color: #000;
  opacity: 0.8;
  font-weight: 400;
}

.form {
  padding: 40px 30px;
  background: #fefefe;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 20px;
  width: 300px;
}
.form h4 {
  margin-bottom: 20px;
  color: rgba(0, 0, 0, 0.5);
}
.form h4 span {
  color: black;
  font-weight: 700;
}
.form p {
  line-height: 155%;
  margin-bottom: 5px;
  font-size: 14px;
  color: #000;
  opacity: 0.65;
  font-weight: 400;
  margin-bottom: 40px;
}

a.discrete {
  color: rgba(0, 0, 0, 0.4);
  font-size: 14px;
  border-bottom: solid 1px rgba(0, 0, 0, 0);
  padding-bottom: 4px;
  margin-left: auto;
  font-weight: 300;
  transition: all 0.3s ease;
  margin-top: 40px;
}
a.discrete:hover {
  border-bottom: solid 1px rgba(0, 0, 0, 0.2);
}

button {
  -webkit-appearance: none;
  width: auto;
  min-width: 100px;
  text-align: center;
  padding: 15px 40px;
  margin-top: 5px;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  color: #fff;
  font-size: 14px;
  margin-left: auto;
  font-weight: 500;
  box-shadow: 0px 2px 6px -1px rgba(0, 0, 0, 0.13);
  border: none;
  transition: all 0.3s ease;
  outline: 0;
}
button:hover {
  transform: translateY(-3px);
  box-shadow: 0 2px 6px -1px rgba(182, 157, 230, 0.65);
}
button:hover:active {
  transform: scale(0.99);
}

input {
  font-size: 16px;
  padding: 20px 0px;
  height: 56px;
  border: none;
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
  background: #fff;
  width: 280px;
  box-sizing: border-box;
  transition: all 0.3s linear;
  color: #000;
  font-weight: 400;
  -webkit-appearance: none;
}
input:focus {
  border-bottom: solid 1px #b69de6;
  outline: 0;
  box-shadow: 0 2px 6px -8px rgba(182, 157, 230, 0.45);
}

.floating-label {
  position: relative;
  margin-bottom: 10px;
  width: 100%;
}
.floating-label label {
  position: absolute;
  top: calc(50% - 7px);
  left: 0;
  opacity: 0;
  transition: all 0.3s ease;
}
.floating-label input {
  width: calc(100%);
  margin-left: auto;
  display: flex;
}
.floating-label .icon {
  position: absolute;
  top: 0;
  left: 0;
  height: 56px;
  width: 44px;
  display: flex;
}
.floating-label .icon svg {
  height: 30px;
  width: 30px;
  margin: auto;
  opacity: 0.15;
  transition: all 0.3s ease;
}
.floating-label .icon svg path {
  transition: all 0.3s ease;
}
.floating-label input:not(:-moz-placeholder-shown) {
  padding: 28px 0px 12px 0px;
}
.floating-label input:not(:-ms-input-placeholder) {
  padding: 28px 0px 12px 0px;
}
.floating-label input:not(:placeholder-shown) {
  padding: 28px 0px 12px 0px;
}
.floating-label input:not(:-moz-placeholder-shown) + label {
  transform: translateY(-10px);
  opacity: 0.7;
}
.floating-label input:not(:-ms-input-placeholder) + label {
  transform: translateY(-10px);
  opacity: 0.7;
}
.floating-label input:not(:placeholder-shown) + label {
  transform: translateY(-10px);
  opacity: 0.7;
}
.floating-label input:valid:not(:-moz-placeholder-shown) + label + .icon svg {
  opacity: 1;
}
.floating-label input:valid:not(:-ms-input-placeholder) + label + .icon svg {
  opacity: 1;
}
.floating-label input:valid:not(:placeholder-shown) + label + .icon svg {
  opacity: 1;
}
.floating-label input:valid:not(:-moz-placeholder-shown) + label + .icon svg path {
  fill: #b69de6;
}
.floating-label input:valid:not(:-ms-input-placeholder) + label + .icon svg path {
  fill: #b69de6;
}
.floating-label input:valid:not(:placeholder-shown) + label + .icon svg path {
  fill: #b69de6;
}
.floating-label input:not(:valid):not(:focus) + label + .icon {
  -webkit-animation-name: shake-shake;
          animation-name: shake-shake;
  -webkit-animation-duration: 0.3s;
          animation-duration: 0.3s;
}

@-webkit-keyframes shake-shake {
  0% {
    transform: translateX(-3px);
  }
  20% {
    transform: translateX(3px);
  }
  40% {
    transform: translateX(-3px);
  }
  60% {
    transform: translateX(3px);
  }
  80% {
    transform: translateX(-3px);
  }
  100% {
    transform: translateX(0px);
  }
}

@keyframes shake-shake {
  0% {
    transform: translateX(-3px);
  }
  20% {
    transform: translateX(3px);
  }
  40% {
    transform: translateX(-3px);
  }
  60% {
    transform: translateX(3px);
  }
  80% {
    transform: translateX(-3px);
  }
  100% {
    transform: translateX(0px);
  }
}
.session {
  display: flex;
  flex-direction: row;
  width: auto;
  height: auto;
  margin: auto auto;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 10px 10px 6px -1px rgba(0, 0, 0, 0.12);
}

.left {
  width: 250px;
  height: auto;
  min-height: 100%;
  position: relative;
  background-image: url("../assets/logo.png");
  background-size: cover;
  background-position: -100px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: transparent;
}
.left svg {
  height: 40px;
  width: auto;
  margin: 20px;
}

select {
  width: 100%;
  margin-top: 10px;
  border: none;

   -o-appearance: none;
   -ms-appearance: none;
   -webkit-appearance: none;
   -moz-appearance: none;
   appearance: none;

}
select::-ms-expand {
    display: none;
}
select:focus {
  outline: none;
}




</style>
<script>
import {Html5Qrcode} from "html5-qrcode";

export default ({
  props: ['transl', 'translation'],
  watch: {
    currLang() {
      var newLang = this.currLang;
      this.$emit("SetLang", newLang)
    }
  },
    data() {
        return {
          currLang: 'de',
          mode: 'form',
            username: null,
            password: null,
            success: false,
            fail: false,
            hasauth: false,
        }    
    },
    mounted() {
      let { query = {} } = this.$route.params;
      let { tk = false } = query;
      if(tk) this.ParseScannedData(tk);
        this.$refs.username.focus();
        let { custid = null } = this.$route.params;
        if(custid) {
          let params = new URLSearchParams(location.search);
          this.username = params.get("email");       
          this.password = custid;
          this.Login();
        }
    },
    methods: {
      ParseScannedData(data) {
              if(this.hasauth) return false;
              let params = new URLSearchParams(data.substring(data.indexOf("?")))
              var token = params.get("tk");
              this.$store.dispatch("QRCodeAuth", data)
              .then(() => {
                this.hasauth = true;
                this.$router.push({
                  name: "dashboard",
                });
                this.success = true;
                this.fail = false;
              })
              .catch(() => {
                this.fail = true;
                setTimeout(() => {
                  this.fail = false;
                }, 1500)
              })
      },
      QRLogin() {
        this.mode ="qrcode";
        Html5Qrcode.getCameras().then(devices => {
          if (devices && devices.length) {
            const config = { fps: 2};
            const html5QrCode = new Html5Qrcode("reader");
            html5QrCode.start({ facingMode: { exact: "environment"} }, config, (decodedText, decodedResult) => {
              this.ParseScannedData(decodedText);
            }).catch((err) => {
              this.mode ="form";
              setTimeout(() => {
                this.$refs.username.focus();
              },900)
            })
          }
        });
      },
      dashboard() {
          this.$router.push({
              name: 'dashboard',
          })
      },
      Login() {
        this.$store.dispatch("Login", {
            username: this.username,
            password: this.password,
        }).then((user) => {

          document.title = document.title+" :: "+user.name;
          let { next = "dashboard", params= {} } = this.$route.params;

          if (this.$store.getters.isAdmin) {
            next = "ShowClients";
          }

          this.$router.push({
            name: next,
            params: params,
          })


        }).catch(() => {
          this.$refs.username.value="";
          this.$refs.password.value="";
          this.$refs.username.focus();
          
        })
      },
      GetVersion() {
        // const fs = require('fs');
        // const packageJson = fs.readFileSync('./package.json');
        // const version = JSON.parse(packageJson).version || 0;
        return "V0.39";
      }
    }
})
</script>
